export const getters = {
  getUser: state => {
    state.userData = JSON.parse(sessionStorage.getItem("userData"));
    return state.userData;
  },
  getRoles: state => {
    const roleData = JSON.parse(sessionStorage.getItem("userRoles"));
    if (roleData?.role) {
      state.roles = roleData.role;
    }
    return state.roles;
  },
  getToken: state => {
    // return sessionStorage.getItem("token");
    return state.token;
  },
  isAuthenticated: state => {
    state.token = sessionStorage.getItem("token");
    return state.token !== null && typeof state.token !== "undefined";
  },
  getLoggedInName: state => {
    if (state.userData) {
      let name = `${state.userData.first_name} ${state.userData.last_name}`;
      if (!name.trim()) {
        name = state.userData.username;
      }
      if (!name.trim()) {
        name = state.userData.email;
      }
      return name;
    } else return "";
  }
};
